export const FRIENDS_DATA = {
  playerFriendId: "F7X9K2M4",
  friends: [],
  requests: [],
  pendingRequests: []
};
